<template>
  <el-form
    id="notice-form"
    :model="ruleForm"
    :rules="rules"
    ref="form"
    label-width="90px"
    size="small"
  >
    <el-form-item label="启用通知" prop="delivery">
      <el-switch
        :disabled="disabled"
        v-model="ruleForm.delivery"
        @change="change"
      ></el-switch>
    </el-form-item>
    <el-form-item label="事件类型" prop="type">
      <el-checkbox-group v-model="ruleForm.type">
        <el-checkbox
          :disabled="!ruleForm.delivery || disabled"
          label="FAILED"
          name="type"
          class="fbx"
          >失败</el-checkbox
        >
        <el-checkbox
          :disabled="!ruleForm.delivery || disabled"
          label="TIMEOUT"
          name="type"
          class="fbx"
          >超时</el-checkbox
        >
        <el-checkbox
          :disabled="!ruleForm.delivery || disabled"
          label="STARTED"
          name="type"
          class="fbx"
          >开始</el-checkbox
        >
        <el-checkbox
          :disabled="!ruleForm.delivery || disabled"
          label="FINISHED"
          name="type"
          class="fbx"
          >完成</el-checkbox
        >
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="通知类型" prop="infotype">
      <el-checkbox-group v-model="ruleForm.infotype">
        <el-checkbox
          :disabled="!ruleForm.delivery || disabled"
          label="EMAIL"
          class="fbx"
          >邮件</el-checkbox
        >
        <el-checkbox
          :disabled="!ruleForm.delivery || disabled"
          label="DINGDING"
          class="fbx"
          >钉钉</el-checkbox
        >
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="超时设置" required style="margin-bottom:0;">
      <el-col :span="10">
        <el-form-item prop="time">
          <el-input
            :disabled="!ruleForm.delivery || disabled"
            v-model.number="ruleForm.time"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6" :offset="1">
        <el-form-item prop="date2">
          <el-select
            :disabled="!ruleForm.delivery || disabled"
            v-model="ruleForm.timeUnit"
            class="selectinit"
          >
            <el-option label="时" value="s"></el-option>
            <el-option label="分" value="f"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="本组通知">
      <el-col :span="7">
        <el-form-item label="" style="margin-bottom:0;">
          <el-checkbox
            :disabled="!ruleForm.delivery || disabled"
            v-model="ruleForm.sendDefaultEmail"
            >本组邮箱</el-checkbox
          >
        </el-form-item>
      </el-col>
      <el-col :span="7" :offset="1">
        <el-form-item label="" style="margin-bottom:0;">
          <el-checkbox
            :disabled="!ruleForm.delivery || disabled"
            v-model="ruleForm.sendDefaultDing"
            >本组钉钉</el-checkbox
          >
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="组外邮箱" prop="emailAddr">
      <el-input
        :disabled="!ruleForm.delivery || disabled"
        v-model.number="ruleForm.emailAddr"
      ></el-input>
    </el-form-item>

    <el-form-item label="组外钉钉" prop="dingAddr">
      <el-input
        :disabled="!ruleForm.delivery || disabled"
        v-model.number="ruleForm.dingAddr"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "notice-form",
  props: {
    groupId: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    notice: {
      type: Object
    }
  },
  data() {
    const validatorEmail = (rule, value, callback) => {
      // let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (this.ruleForm.infotype.includes("EMAIL")) {
        if (this.ruleForm.sendDefaultEmail || this.ruleForm.emailAddr) {
          callback();
        } else {
          callback(new Error("请填写邮箱地址或选中本组邮箱"));
        }
      }
      callback();
    };
    const validatorEmail2 = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;

      let arr = value.split(",");

      arr.forEach(v => {
        if (!reg.test(v)) {
          callback(new Error("邮箱格式填写错误，多个邮箱请用‘,’分隔"));
        }
      });
      callback();
    };
    const validatorDing = (rule, value, callback) => {
      if (this.ruleForm.infotype.includes("DINGDING")) {
        if (this.ruleForm.sendDefaultDing || this.ruleForm.dingAddr) {
          callback();
        } else {
          callback(new Error("请填写钉钉地址或选中本组钉钉"));
        }
      }
      callback();
    };
    return {
      ruleForm: {
        emailAddr: "",
        dingAddr: "",
        sendDefaultEmail: false,
        sendDefaultDing: true,
        type: ["FAILED", "TIMEOUT"],
        infotype: ["DINGDING"],
        time: 30,
        timeUnit: "f",
        delivery: true
      },
      rules: {
        emailAddr: [
          {
            validator: validatorEmail,
            trigger: "blur"
          },
          {
            validator: validatorEmail2,
            trigger: "change"
          }
        ],
        sendDefaultEmail: [
          {
            validator: validatorEmail,
            trigger: "change"
          }
        ],
        dingAddr: [
          {
            validator: validatorDing,
            trigger: "blur"
          }
        ],
        sendDefaultDing: [
          {
            validator: validatorDing,
            trigger: "change"
          }
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个事件类型",
            trigger: "change"
          }
        ],
        infotype: [
          {
            required: true,
            type: "array",
            message: "请至少选择一个通知类型",
            trigger: "change"
          }
        ],
        time: [
          {
            required: true,
            type: "number",
            message: "请输入超时时间",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    notice: {
      immediate: true,
      handler(v) {
        if (v) {
          this.ruleForm = JSON.parse(JSON.stringify(v));
        }
      }
    }
  },
  methods: {
    change() {
      this.$refs.form.clearValidate();
    },
    validate() {
      return new Promise((resolve, reject) => {
        if (this.ruleForm.delivery) {
          this.$refs.form.validate(valid => {
            if (valid) {
              resolve(this.ruleForm);
            } else {
              this.$message({
                type: "error",
                message: `通知设置参数填写错误`
              });
              reject("third");
            }
          });
        } else {
          resolve(this.ruleForm);
        }
      });
    }
  }
};
</script>

<style lang="scss">
#notice-form {
  padding: 15px 10px;
  .el-checkbox + .el-checkbox {
    margin-left: 20px;
  }
}
</style>
